import React, { useRef } from 'react';
import { TextLink, IconButton, Dialog } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';
import { useServicesContext } from '../../../../../context';
import { usePriceConfiguration } from '../../../../../hooks';
import { dynamicStylingHelper } from '../../../../utils/AlphaHelper';
import { PriceBreakdownModalContent } from './PriceBreakdownModalContent';
import { trackAdditionalFinanceInfo, trackLayerClose } from '../FinanceTracking';
let instanceCounter = 0;
export const PriceBreakdownCta = ({ vehicle, variant = 'text', }) => {
    var _a;
    const scopeKeyRef = useRef(null);
    if (!scopeKeyRef.current) {
        instanceCounter += 1;
        scopeKeyRef.current = `priceBreakDownLayer_${instanceCounter}`;
    }
    const logger = (_a = useServicesContext().getAdditionalService('s2:logger')) !== null && _a !== void 0 ? _a : console;
    const configuration = useServicesContext().getConfiguration();
    const footnoteReferenceServiceScopeManager = useServicesContext().getAdditionalService('audi-footnote-reference-service');
    const trackingService = useServicesContext().getAdditionalService('audi-tracking-service');
    const ariaLabelCta = useI18n({
        id: 'stockcars.prices.pricebreakdown.cta.arialabel',
        defaultMessage: '',
    });
    const textLinkLabel = useI18n({
        id: 'stockcars.prices.pricebreakdown.textlink.label',
        defaultMessage: '',
    });
    const priceDialogAriaLabel = useI18n({
        id: 'stockcars.prices.pricebreakdown.dialog.arialabel',
        defaultMessage: '',
    });
    const priceDialogCloseButtonAriaLabel = useI18n({
        id: 'stockcars.prices.pricebreakdown.dialog.closebutton.arialabel',
        defaultMessage: '',
    });
    const { priceConfiguration } = configuration;
    if (!priceConfiguration || priceConfiguration.length < 1)
        return null;
    const hasMatchingRelevancy = priceConfiguration === null || priceConfiguration === void 0 ? void 0 : priceConfiguration.some((priceItem) => {
        var _a, _b, _c;
        return ((_a = priceItem === null || priceItem === void 0 ? void 0 : priceItem.fields) === null || _a === void 0 ? void 0 : _a.availability) === (vehicle === null || vehicle === void 0 ? void 0 : vehicle.availableFromCode) &&
            ((_b = priceItem === null || priceItem === void 0 ? void 0 : priceItem.fields) === null || _b === void 0 ? void 0 : _b.businessModel) === ((_c = vehicle === null || vehicle === void 0 ? void 0 : vehicle.businessModel) === null || _c === void 0 ? void 0 : _c.code);
    });
    if (!hasMatchingRelevancy) {
        return null;
    }
    const priceGroups = usePriceConfiguration(vehicle, priceConfiguration, logger);
    const [isPriceBreakDownDialogOpen, setIsPriceBreakDownDialogOpen] = React.useState(false);
    const openFocusLayer = () => {
        setIsPriceBreakDownDialogOpen(true);
        trackAdditionalFinanceInfo(trackingService, 'vtp click on additional price infos');
    };
    const closeFocusLayer = () => {
        trackLayerClose(trackingService, 'vtp additional price infos');
        setIsPriceBreakDownDialogOpen(false);
    };
    return (React.createElement(React.Fragment, null,
        variant === 'text' && (React.createElement(TextLink, { "data-testid": "pricebreakdown-textlink", onClick: openFocusLayer, size: "sm", "aria-label": ariaLabelCta, variant: "standalone" }, textLinkLabel)),
        variant === 'icon' && (React.createElement(IconButton, { icon: "info-circle", id: "icon-button-id", onClick: openFocusLayer, size: dynamicStylingHelper('md', 'xs'), type: "button", "data-testid": "pricebreakdown-icon-button", "aria-label": ariaLabelCta, variant: "tertiary" })),
        isPriceBreakDownDialogOpen && (React.createElement(Dialog, { "aria-label": priceDialogAriaLabel, onCloseButtonAriaLabel: priceDialogCloseButtonAriaLabel, hasCloseButton: true, variant: "focus-large", open: isPriceBreakDownDialogOpen, onClose: () => {
                closeFocusLayer();
            } },
            React.createElement(PriceBreakdownModalContent, { vehicle: vehicle, priceGroups: priceGroups, footnoteReferenceServiceScopeManager: footnoteReferenceServiceScopeManager, scopeKey: scopeKeyRef.current })))));
};
